import FSelect from '@/plugins/form/FSelect';
import api from '@/plugins/api';
import component from './component.vue';
import { sortLabel } from '@/utils/array';
import core from "@/core";

export default class FTourDictionary extends FSelect {
  __component = component;

  __init = false;

  constructor(props = {}) {
    super(props);
    if (props.dictionary) {
      this.dictionary = props.dictionary;
    }
    this.refs.$subscribe(model => this.getOptions(model));
  }

  __formatting(data) {
    return data.map(i => ({
      value: i.id,
      label: i.name,
      ...i,
    }));
  }

  getOptions(model = this.refs.data) {
    if (this.dictionary === 'OwnerLegal') {
      model.partner = core.account.partner
    }
    const request = {
      dictionary: this.dictionary,
      ...model,
    };
    this.options = [];
    this.loading = true;
    this.disabled = true;
    return api.tour
      .dictionary(request)
      .then((data) => {
        const options = this.__formatting(data);
        this.setOptions(options);
        return Promise.resolve(options);
      })
      .finally(() => {
        this.disabled = false;
        this.loading = false;
      });
  }

  setOptions(options = []) {
    sortLabel(options);
    this.options = options;
    if (this.__init && this.value && !this.options.find(i => i.value === this.value.value)) {
      this.value = null;
    }
    return this;
  }

  init() {
    return this.getOptions()
      .then((d) => {
        this.__init = true;
        return d;
      });
  }
}
